import React from 'react'
import ContentLoader from 'react-content-loader'

const backgroundColor = "#353530"
const foregroundColor = "#666660"

export const WalletSkeleton = () => (
  <div className="min-h-screen w-full text-white p-4">
    <div className="">
      {/* Header */}
      <ContentLoader width={'100%'} height={60} backgroundColor={backgroundColor} foregroundColor={foregroundColor} className="mb-6">
        <rect x="0" y="0" rx="5" ry="5" width="200" height="40" />
      </ContentLoader>

      {/* Balance Cards Section */}
      <div className="space-y-4 mt-4">
        {/* First Balance Card Skeleton */}
        <ContentLoader width={'100%'} height={220} backgroundColor={backgroundColor} foregroundColor={foregroundColor} className="rounded-lg">
          {/* Card background */}
          <rect x="0" y="0" rx="12" ry="12" width="100%" height="220" />
          
          {/* Title */}
          <rect x="24" y="20" rx="5" ry="5" width="180" height="16" fill={backgroundColor} />
          
          {/* Balance amount */}
          <rect x="24" y="55" rx="5" ry="5" width="220" height="32" fill={backgroundColor} />
          
          {/* Currency symbol */}
          <rect x="24" y="100" rx="5" ry="5" width="40" height="20" fill={backgroundColor} />
          
          {/* Action buttons */}
          <rect x="24" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
          <rect x="130" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
          <rect x="236" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
        </ContentLoader>

        {/* Second Balance Card Skeleton */}
        <ContentLoader width={'100%'} height={220} backgroundColor={backgroundColor} foregroundColor={foregroundColor} className="rounded-lg">
          {/* Card background */}
          <rect x="0" y="0" rx="12" ry="12" width="100%" height="220" />
          
          {/* Title */}
          <rect x="24" y="20" rx="5" ry="5" width="180" height="16" fill={backgroundColor} />
          
          {/* Balance amount */}
          <rect x="24" y="55" rx="5" ry="5" width="220" height="32" fill={backgroundColor} />
          
          {/* Sub value */}
          <rect x="24" y="100" rx="5" ry="5" width="60" height="16" fill={backgroundColor} />
          
          {/* Action buttons */}
          <rect x="24" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
          <rect x="130" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
          <rect x="236" y="145" rx="8" ry="8" width="90" height="40" fill={backgroundColor} />
        </ContentLoader>
      </div>

      {/* Transaction Section Skeleton */}
      <div className="mt-8">
        {/* Transaction header */}
        <ContentLoader width={'100%'} height={50} backgroundColor={backgroundColor} foregroundColor={foregroundColor} className="mb-4">
          <rect x="0" y="0" rx="5" ry="5" width="180" height="28" />
        </ContentLoader>

        {/* Transaction items */}
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <ContentLoader
              key={i}
              width={'100%'}
              height={80}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
              className="rounded-lg"
            >
              <circle cx="25" cy="40" r="20" fill={backgroundColor} />
              <rect x="60" y="20" rx="5" ry="5" width="150" height="14" fill={backgroundColor} />
              <rect x="60" y="42" rx="5" ry="5" width="100" height="12" fill={backgroundColor} />
              <rect x="85%" y="30" rx="5" ry="5" width="80" height="20" fill={backgroundColor} />
            </ContentLoader>
          ))}
        </div>
      </div>
    </div>
  </div>
)

export default WalletSkeleton
